// export const IMG_URL = "http://127.0.0.1:1515";
// export const IMG_URL = "https://myflowereventnode.profcymadev.com:1519";
export const IMG_URL = "https://node.myflowermemories.com";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};
